import { createFileRoute, Link } from "@tanstack/react-router";
import { useSEO } from "../../hooks/useSEO";
import { SEO_CONFIG } from "../../seo/seoConfig";
import { getAllPosts } from "../../blog/posts";

export const Route = createFileRoute("/blog/")({
  component: BlogIndexPage,
});

function formatDate(iso: string): string {
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return iso;
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
}

function BlogIndexPage() {
  const posts = getAllPosts();

  useSEO(SEO_CONFIG["/blog"]!);

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-3xl px-4 py-12 sm:py-16">
        <header className="mb-10">
          <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">Blog</h1>
          <p className="mt-3 text-lg text-foreground/80">
            Guides on agency client reporting, automation, and AI-assisted analytics.
          </p>
        </header>

        {posts.length === 0 ? (
          <p className="text-muted-foreground">No articles yet — check back soon.</p>
        ) : (
          <ul className="space-y-8">
            {posts.map((post) => (
              <li key={post.slug} className="border-b-[0.5px] border-input pb-8 last:border-b-0">
                <div className="mb-1 flex flex-wrap items-center gap-x-2 text-sm text-muted-foreground">
                  <span>{post.frontmatter.category}</span>
                  <span aria-hidden>·</span>
                  <time dateTime={post.frontmatter.publishedAt}>
                    {formatDate(post.frontmatter.publishedAt)}
                  </time>
                  <span aria-hidden>·</span>
                  <span>{post.readingTimeMinutes} min read</span>
                </div>
                <h2 className="text-xl font-semibold tracking-tight">
                  <Link
                    to="/blog/$slug"
                    params={{ slug: post.slug }}
                    className="text-foreground hover:text-brand"
                  >
                    {post.frontmatter.title}
                  </Link>
                </h2>
                <p className="mt-1.5 text-foreground/80">{post.frontmatter.description}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
